<template>
  <div class="content" id="targets">
    <section class="datepicker"><form id="datepickerform"><label>Choose Date: </label><input type="date" name="pickdate" v-model="targetDate" min="2020-10-08" @change="changeTargetDate()"></form>
    </section>
    <section v-for="(items, category) in currentTargets" :class="category" :key="category">
      <form @submit.prevent class="targetsform">
      <table>
        <thead>
          <tr><th>&nbsp;</th><th>{{category}}: <span class="fromto">{{items.from}} &rarr; {{items.to}}</span></th><th>&nbsp;</th></tr>
        </thead>
      <tbody>
        <tr v-for="(target, index) in items.targets" :key="category+'_'+ target.id+'_'+index">
          <td><input type="hidden" :name="category+'_id_'+index" v-model="target.id"><input type="checkbox" :name="'done_'+index" value="Y" v-model="target.done"></td>
          <td><input type="text" :id="'description_'+index" v-model="target.description"></td>
          <td><input type="number" :id="'priority_'+index" min="0" max="100" step="1" v-model.number="target.priority"></td>
        </tr>
      </tbody>
      </table>
      <button class="btnsave" @click="saveTargets(category,$event)">Save</button><span class="onemore" @click="addNewTarget(category,$event)">+</span><div class="message">&nbsp;</div>
      </form>
    </section>

  </div>
</template>
<script>
import dateHelper from '@/helpers/dateHelper'
import {mapActions } from "vuex";

export default {
  data(){
    return{
      currentTargets: {},
      docID:'', 
      targetDate:''
    }
  },
  //
  computed:{
    currentDate(){
      return dateHelper.getDisplayDate(this.$route.params.date);
    },
    //
    category(){
      return this.$route.params.category;
    }
  },
  //
  methods:{
    ...mapActions('targetStore', ['fetchTargets', 'saveUploadTargets']),

    setDefaultTargets(){
      const date=this.targetDate;
      this.$store.state.targetStore['categories'].forEach(category => {
        this.currentTargets[category]={
          ...dateHelper.getDateSpan(category, date),
          targets: this.getDefaultTargets()
        };
      })
    },
    //
    getTargetItem(priority=0){
      return {id: dateHelper.getUniqueID(), description:'', priority, done: false};
    },
    //
    getDefaultTargets(start=0){
      var targets=[];
        for(let i=start; i<5; i++){
          targets.push(this.getTargetItem(i));
        }
        return targets;
    },
    //
    mergeCategoryTargets(storeData, category){
      if(!storeData['targets'] || storeData['targets'].length==0){return;}
      //console.log(category, 'store data:', storeData)
      var nitems=storeData['targets'].length;

      this.currentTargets[category]={
        from:storeData['from'],
        to: storeData['to'],
        targets: [].concat(storeData['targets'], this.getDefaultTargets(nitems))
      };
    },

    //
    saveTargets(category){
      console.log('Request to save', category, 'targets')
      const targets=this.currentTargets[category]['targets'].filter(item => item.description.trim()!='');
      const payload={
        category, 
        targets,
        from: this.currentTargets[category]['from'], 
        to: this.currentTargets[category]['to']
      };

      this.saveUploadTargets(payload, {rootStore:true}).then(()=>{
      }).catch(error =>{
        console.log(error)
      })
    },
    //
    addNewTarget(category){
      const priority=this.currentTargets[category]['targets'].length;
      this.currentTargets[category]['targets'].push( this.getTargetItem(priority));
    },
    //
    getTargetDocumentIDs(){
      const docs=[]
      this.$store.state.targetStore['categories'].forEach(category => {
        docs.push(category+'-'+this.currentTargets[category]['from'])
      });

      return docs;
    },
    //
    downloadTargets(){
      //i.e.['weekly-2020-10-11', 'monthly-2020-10-01', 'quarterly-2020-10-01']
      const docs=this.getTargetDocumentIDs()

      this.fetchTargets({docs}, {rootStore:true}).then(()=>{
        const storedTargets={...this.$store.state.targetStore.targets}
        Object.keys(storedTargets).forEach(category => {
          this.mergeCategoryTargets(storedTargets[category], category);
        })
      })
    },
    //
    changeTargetDate(){
      this.resetTarget()
    },
    //
    resetTarget(){
      this.setDefaultTargets();
      this.downloadTargets();
    }
  },

  beforeMount (){
    const targetdate=this.$route.params.date || ''
    this.targetDate=dateHelper.getDisplayDate(targetdate)
    console.log('Target Date:', this.targetDate)
    this.resetTarget()
  }
}

/* * Target
 targets:{
   from: '',
   to: '', 
   category: 'weekly', //weekly, monthly, quarterly
   targets:[
      {id: 'auto_generated_id', description: '', priority:0,  done: N}
   ]
 }

*/
</script>
